import { JumpHeader } from '@/components/common/JumpHeader'
import { useScrollspyActiveSlug } from '@/components/providers/ScrollspyProvider'
import { type GalleryGroupType } from '@/defs/gallery'

type Props = {
  groups: GalleryGroupType[]
}

export const GalleryControlsJumpHeader = ({ groups }: Props) => {
  const activeSlug = useScrollspyActiveSlug()

  return <JumpHeader activeSlug={activeSlug} items={groups} offset={12} />
}
